// extracted by mini-css-extract-plugin
export default {"title":"NickoTermsOfLiability_title__8W-ts"};